import { router } from "@inertiajs/react"

/**
 * Custom hook to prefetch Inertia page on hover
 * Usage: const prefetchProps = usePrefetchLink('/dashboard')
 * Then spread prefetchProps on your Link or button element
 */
export function usePrefetchLink(url: string) {
  const handleMouseEnter = () => {
    router.prefetch(url)
  }

  return {
    onMouseEnter: handleMouseEnter,
  }
}
